/* eslint-disable no-undef */

export default {
	name: "modal-message",
	props: ["heading", "elementId", "message", "showModal"],
	emits: ["okClicked"],
	data() {
		return {
		};
	},
	methods: {
		onYesClick(){
			this.$emit("okClicked", true);
		},
		onNoClick(){
			this.$emit("okClicked", true);
		},
		onCloseClick(){
			this.$emit("okClicked", true);
		}
	},
	mounted: function () {
        
	},
	watch: {
		showModal: {
			handler: function () {
				if (this.showModal) {
					$("#" + this.elementId).modal("show");
				}
				else{
					$("#" + this.elementId).modal("hide");
				}
			}
		}
	}
};
